var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1528.5 1089.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1527.4 109.6c0-1.7 1.2-3.4 1.1-5.2l-466.4 449.4L1528 988.9c.3-3.1-.6-6.2-.6-9.4zm-727 696.6c-9.6 9.3-22.1 13.9-34.5 13.9-12.2 0-24.4-4.4-34-13.4L542 629.8l-468.9 452c11.4 4.1 23.6 7.3 36.5 7.3h1312.7c19 0 36.9-5.8 52.4-14.4L990.8 623z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.2 16c-16.1-9.6-34.9-16-55-16H109.6C83.4 0 59.4 10.2 40.7 25.7l724.6 676.1zM0 126.3v853.2c0 9.8 2.3 19.2 4.7 28.3l463.1-446z"
  })));
};
export default SvgEmail;